console.log('child scripts')